import React, { useEffect } from "react";
import Joi from "joi-browser";
import ReCAPTCHA from "react-google-recaptcha";
import useControls from "../../app/hooks/useControls";
import useForm from "../../app/hooks/useForm";

const LoginStep2 = ({ handleDoSubmit, userError, type, handleForgotPwd }) => {
  const schema = {
    username: Joi.string().required().label("Username"),
    password: Joi.string().required().label("Password"),
    ReCAPTCHA: Joi.string().required().label("Re-Captcha"),
  };

  const doSubmit = () => {
    handleDoSubmit(stateData);
  };

  const {
    stateData,
    setStateData,
    stateErrors,
    setStateErrors,
    handleChange,
    validate,
    handleSubmit,
  } = useForm(schema, doSubmit);

  useEffect(() => {
    if (userError !== undefined) {
      setStateErrors((prev) => ({
        ...prev,
        username: userError,
      }));
    }
  }, [userError, setStateErrors]);

  const onCaptchaChange = (value) => {
    setStateData((prev) => ({
      ...prev,
      ReCAPTCHA: value,
    }));
  };

  useEffect(() => {
    const interval = setInterval(() => {
      const recaptchaResponse = document.getElementById("g-recaptcha-response");
      if (recaptchaResponse) {
        recaptchaResponse.setAttribute("aria-label", "Captcha verification");
        recaptchaResponse.setAttribute("tabindex", "-1");
        clearInterval(interval);
      }
    }, 500);
    return () => clearInterval(interval);
  }, []);

  const { renderInput } = useControls(
    stateData,
    stateErrors,
    handleChange,
    schema
  );

  return (
    <>
      {renderInput("username", "Enter Your Username")}
      {renderInput("password", "Enter Your Password", "password")}
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          marginTop: "10px",
          marginBottom: "12px",
          transform: "scale(1.15)",
          transformOrigin: "center top",
        }}
      >
        <ReCAPTCHA
          sitekey="6Le08xsUAAAAAKC6Oglhe-haRVGzA8KTLUZ-jmEK"
          onChange={onCaptchaChange}
        />
      </div>
      <button
        className="btn w-100 mt-1"
        style={{
          backgroundColor: `${type === "admin" ? "#298607" : "#2b62a1"}`,
          color: "white",
        }}
        disabled={!!validate()}
        onClick={handleSubmit}
      >
        SIGN IN
      </button>
      <div className="d-flex justify-content-end">
        <button onClick={handleForgotPwd} className="btn btn-link btn-sm" style={{ fontWeight: "500" }}>
          Forgot Username/Password?
        </button>
      </div>
    </>
  );
};

export default LoginStep2;

